// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import FupOrganisationListPagingResultModel from '../../model/fup-organisation-list-paging-result-model';
import FupOrganisationListPagingResultDTO from '../dto/fup-organisation-list-paging-result-dto';
import dtoSchema from '../schemas/fup-organisation-list-paging-result-schema';
import FupOrganisationListModel from '../../model/fup-organisation-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class FupOrganisationListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<FupOrganisationListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => FupOrganisationListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: FupOrganisationListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<FupOrganisationListPagingResultDTO>): FupOrganisationListPagingResultModel;
  static toModel(dto: DeepPartial<FupOrganisationListPagingResultDTO> | undefined | null): FupOrganisationListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<FupOrganisationListPagingResultDTO> | undefined | null): FupOrganisationListPagingResultModel | undefined {
    return dto ? new FupOrganisationListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<FupOrganisationListPagingResultModel> | FupOrganisationListPagingResultModel): FupOrganisationListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as FupOrganisationListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for FupOrganisationListPagingResultModel, can not map to FupOrganisationListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
